<template>
  <b-card :title="(leitura.unidade && leitura.unidade.descricao) + ' ' + leitura.mesAnoReferencia">
    <b-row>
      <b-col
        cols="12"
        class="button-wrapper mb-1"
      >
        <span
          class="button btn w-100 btn-primary"
          @click="$refs.file.click()"
        >
          <input
            ref="file"
            type="file"
            accept="image/*"
            @change="uploadImage($event)"
          >
          Tirar Foto / Buscar Imagem
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <cropper
          ref="cropper"
          class="cropper"
          :src="image"
          :stencil-props="{
            handlers: {},
            movable: false,
            scalable: false,
          }"
          :stencil-size="{
            width: 480,
            height: 480,
          }"
          :resize-image="{
            adjustStencil: false,
          }"
          image-restriction="stencil"
        />
      </b-col>
    </b-row>
    <validation-observer ref="regras">
      <b-form @submit.prevent="onGravar">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Valor Aferido">
              <validation-provider
                #default="{ errors }"
                name="Valor"
                :rules="{ required: true, min_value: valorMinimo }"
              >
                <b-form-input
                  v-model="leitura.valor"
                  label="Leitura Aferida"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Leitura Aferida"
                  type="number"
                  step="0.001"
                  min="0"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="text-muted d-block mt-25">
                  Informe o número do hidrômetro com a vírgula, ex.: 3931,834
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            lg="6"
            align="left"
            class="mb-2"
          >
            <h3>Data de realização da leitura</h3>
            <flat-pickr
              v-model="leitura.dataLeitura"
              class="form-control"
              :config="dateConfig"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-button
              class="w-100"
              variant="primary"
              type="submit"
              :disabled="salvando"
            >
              <b-spinner
                v-if="salvando"
                small
              />
              <span v-else>Salvar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BFormInput, BFormGroup, BForm, BSpinner,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import ImagemAPI from '@/api/imagem'

export default {
  components: {
    BFormInput,
    flatPickr,
    BForm,
    BFormGroup,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    Cropper,
  },
  data() {
    return {
      dateConfig: {
        dateFormat: 'Z',
        locale: Portuguese,
        inline: true,
      },
      image: null,
      novaFotoSelecionada: false,
      salvando: false,
      // Valor da última leitura pré-preenchido ao abrir a tela; usado como
      // baseline para validação e checagem de sanidade do consumo.
      valorBaseline: 0,
      required,
      leitura: {
        valor: 0,
        dataLeitura: new Date(),
        foto: null,
      },
    }
  },
  computed: {
    leituraEmEdicao() {
      return this.$store.state.leitura.leituraEmEdicao
    },
    // Valor mínimo aceito: nunca menor que a leitura anterior; quando não há
    // baseline, exige valor positivo (> 0).
    valorMinimo() {
      return this.valorBaseline > 0 ? this.valorBaseline : 0.001
    },
  },
  created() {
    this.leitura = this.leituraEmEdicao
    this.valorBaseline = Number(this.leitura && this.leitura.valor) || 0
    if (this.leitura && this.leitura.idFoto) {
      ImagemAPI.obter(this.leitura.idFoto).then(foto => {
        this.image = `data:image/jpeg;base64,${foto.data}`
      })
    }
  },
  methods: {
    cropImage() {
      if (!this.image) return null
      const result = this.$refs.cropper.getResult()
      return result.canvas.toDataURL('image/jpeg')
      // const newTab = window.open()
      // newTab.document.body.innerHTML = `<img src="${result.canvas.toDataURL('image/jpeg',)}"></img>`
    },
    uploadImage(event) {
      // Reference to the DOM input element
      const input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        const reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.image = e.target.result
          this.novaFotoSelecionada = true
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },
    onGravar() {
      // Guard contra duplo-clique: se já está salvando, ignora novos submits.
      if (this.salvando) return
      this.$refs.regras.validate().then(async result => {
        if (!result) return

        // Checagem de sanidade: pega erro de vírgula decimal (ex.: 3931834 em
        // vez de 3931,834) sem bloquear consumos legítimos.
        if (await this.valorPareceAlto()) return

        // Só trava o botão depois que a validação/confirmação passaram, para não
        // deixar o botão permanentemente desabilitado em form inválido.
        this.salvando = true
        const payload = { ...this.leitura }
        if (this.novaFotoSelecionada) {
          payload.foto = this.cropImage()
        } else {
          delete payload.foto
        }
        this.$store
          .dispatch('leitura/save', payload)
          .then(() => {
            this.$toast.success('Leitura gravada com sucesso.')
            this.$router.go(-1)
          })
          .catch(err => {
            this.$toast.error(err.response.data)
          })
          .finally(() => {
            this.salvando = false
          })
      })
    },
    // Retorna true quando o usuário cancela a confirmação de valor muito alto.
    async valorPareceAlto() {
      const TETO_ABSOLUTO = 1000000
      const valor = Number(this.leitura.valor)
      const muitoAlto = (this.valorBaseline > 0 && valor > this.valorBaseline * 10)
        || valor > TETO_ABSOLUTO
      if (!muitoAlto) return false
      const confirmado = await this.$bvModal.msgBoxConfirm(
        `O valor informado parece muito alto (${valor}). Confirma que o número do hidrômetro está correto?`,
        {
          title: 'Confirmar leitura',
          okTitle: 'Sim, está correto',
          cancelTitle: 'Revisar',
          cancelVariant: 'outline-secondary',
        },
      )
      return !confirmado
    },
    showSuccess(msg) {
      this.$toast.success(msg)
    },
  },
}
</script>

<style>
.example-cropper {
  border: solid 1px #eee;
  min-height: 300px;
  width: 100%;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  background: #24004d;
  cursor: pointer;
  transition: background 0.5s;
  font-family: Open Sans, Arial;
  margin: 0 10px;
}

.button:hover {
  background: #5a00c0;
}

.button input {
  display: none;
}

.cropper {
  max-height: 480px;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.flatpickr-input {
  display: none;
}
</style>
